import ExtendableError from './ExtendableError.js';
export default class MissingContainerError extends ExtendableError {
    constructor(message, e) {
        super(message + '\n' + e.message);
    }
}
